import { pos65for } from "./pos65for"
import { pos66 } from "./pos66"
import { pos66mzona } from "./pos66mzona"
import { pos66vonalszoros } from "./pos66vonalszoros"
import { pos66zonavedekezes } from "./pos66zonavedekezes"
import { posfor1es } from "./posfor1es"
import { posfor2es } from "./posfor2es"
import { posfor3as } from "./posfor3as"
import { posfor4es } from "./posfor4es"
import { posfor33 } from "./posfor33"
import { posfordupla } from "./posfordupla"
import { pos65for as hbPos65for } from "./handball/pos65for"
import { pos66 as hbPos66 } from "./handball/pos66"
import { pos76 as hbPos76 } from "./handball/pos76"
import { Formation } from "../types"
import { isHandball } from "../sportConfig"

// Waterpolo: 11 formations on a 25x15 m pool.
const waterpoloPositions: Formation[] = [
  pos65for,
  pos66,
  pos66mzona,
  pos66vonalszoros,
  pos66zonavedekezes,
  posfor1es,
  posfor2es,
  posfor3as,
  posfor4es,
  posfor33,
  posfordupla,
]

// Handball: 3 formations on a 40x20 m court. Coordinates live in a different
// space, so these are separate files (see ./handball). Contracts preserved
// across both sets: index 0 is "pos65for" and index 1 is the "pos66" default
// tactic (consumed by TacticBoard's free-tier folder and store/tactic.ts).
const handballPositions: Formation[] = [hbPos65for, hbPos66, hbPos76]

export const positions: Formation[] = isHandball
  ? handballPositions
  : waterpoloPositions
